// /assets/cart-format-override.js
//
// Strips the ".00" from every price rendered through Alpine's cart store
// ($store.cart.format), matching the shop money format ${{amount_no_decimals}}.
//
// WHY THE PATCH IS APPLIED ON `alpine:init`
// Alpine dispatches `alpine:init` inside Alpine.start(), AFTER the cart store
// is registered and BEFORE any x-text binding is evaluated. This file is loaded
// as a classic (non-deferred) script tag at the end of <body>, so it runs while
// the document is still parsing; the theme's `type="module"` bundle (which
// creates window.Alpine and calls Alpine.start()) only runs after parsing
// finishes. The listener is therefore always in place before the first render,
// and the very first paint of every price is already decimal-free.
//
// HISTORY (2026-09-05): the previous version polled every second until Alpine
// existed and patched AFTER the first render. Reassigning `format` on the
// reactive store re-ran every price binding on the page, which produced a
// visible "$24.00" -> "$24" flicker on product pages.
(function () {
  function patchCartFormat() {
    if (!window.Alpine || typeof Alpine.store !== 'function') {
      return false;
    }

    var store;
    try {
      store = Alpine.store('cart');
    } catch (e) {
      return false;
    }

    if (!store || typeof store.format !== 'function') {
      return false;
    }

    // Avoid patching multiple times on the same store instance
    if (store.__formatPatched) {
      return true;
    }

    var originalFormat = store.format.bind(store);

    store.format = function (amount, options) {
      // Call the original formatter first (forwarding options such as
      // { trailingZeros: false }, which some callers pass explicitly)
      var result = originalFormat(amount, options);

      // If it returns a string like "$159.00", strip the ".00" at the end
      if (typeof result === 'string') {
        result = result.replace(/\.00\b/, '');
      }

      return result;
    };

    store.__formatPatched = true;
    return true;
  }

  // Normal path: Alpine has not started yet; patch the store the moment Alpine
  // announces itself, before any binding renders.
  document.addEventListener('alpine:init', patchCartFormat);

  // Fallback: if this script is ever loaded after Alpine has already started
  // (for example injected late by a layout that defers it), patch immediately.
  patchCartFormat();
})();
